import React from 'react'
import { useTranslation } from "react-i18next";

import logo from '../../../assets/logo_gray.png';
import Question from '../components/question'

export default function PrintView({ data, targetRef, hidden }) {
    const { t } = useTranslation();
    return (
        <div className={hidden ? 'printBoxTasksOut' : "none"} ref={targetRef}>
            <page Size="A4" className='pdfPrintBox'>
                <img className='logo' src={logo} />
                <div className='pdfNameDateBox'>
                    <div>
                        {t("name")}: _____________
                    </div>
                    <div>
                        {t("date")}: _____________
                    </div>
                </div>
                <div className='pdfStory' dangerouslySetInnerHTML={{ __html: data?.task?.story}} >
                    
                </div>
            </page>
            
            
            <page Size="A4" className='pdfPrint'>  
                        
                {data?.task?.questions?.map((v, k) => {
                    
                    return (
                        <Question k={k} key={k} data={v} print={true} show={true}/>
                    );
                })}
            </page>

            
        </div>
    )
}
